import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const BaseIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 8c0 4.142-3.364 7.5-7.513 7.5A7.509 7.509 0 0 1 .5 8.63h9.93V7.37H.5A7.509 7.509 0 0 1 7.987.5C12.137.5 15.5 3.858 15.5 8Z", fill: "currentColor" })));
});
BaseIcon.displayName = 'BaseIcon';
export default BaseIcon;
